import ContentElement from "./content-element.js";

const bootstrap = window.bootstrap;

interface OffcanvasContainerConfig extends bootstrap.Offcanvas.Options {
    binding: string;
    size: string;
    active: boolean;
    fixed: boolean;
    keyboard: boolean;
    exclusive: boolean;
    backdrop: boolean;
}

const DEFAULT_ELEMENT_SELECTOR: string = '.th-fsc-offcanvas.offcanvas';

const defaultOptions: OffcanvasContainerConfig = {
    binding: '',
    size: '',
    active: false,
    fixed: false,
    exclusive: false,
    keyboard: true,
    backdrop: true,
    scroll: false
};

const offcanvasInstanceMap = new Map<HTMLElement, bootstrap.Offcanvas>();

class OffcanvasContainer extends ContentElement {
    protected options: OffcanvasContainerConfig;
    protected isLoaded: boolean = false;
    protected container: HTMLElement;
    protected instance: bootstrap.Offcanvas;
    protected offcanvasControlEl:HTMLElement;
    protected offcanvasControlButtonEl:HTMLElement;

    public override init() {
        this.options = this.assignConfig<OffcanvasContainerConfig>(defaultOptions, this.config);
    }

    public override process() {
        const self = this;
        this.offcanvasControlEl = this.element.querySelector<HTMLElement>('.offcanvas-control')!;
        this.offcanvasControlButtonEl = this.element.querySelector<HTMLElement>('.offcanvas-control-button')!;

        this.instance = new bootstrap.Offcanvas(this.element, this.config)
        offcanvasInstanceMap.set(this.element, this.instance);

        if(this.options.size != '') {
            if(this.element.classList.contains('offcanvas-start') || this.element.classList.contains('offcanvas-end')) {
                this.element.style.width = this.options.size;
            } else {
                this.element.style.height = this.options.size;
            }
        }

        // Handle binding
        if(this.options.binding == '' && this.element.parentElement) {
            if(this.element.parentElement.style.position != 'relative') {
                this.element.parentElement.style.position = 'relative';
            }
            if(this.element.parentElement.style.overflow != 'hidden') {
                this.element.parentElement.style.overflow = 'hidden';
            }

            self.container = this.element.parentElement;
        } else if(this.options.binding != '') {
            const contextEl:HTMLElement | null = document.querySelector<HTMLElement>(this.options.binding);
            if(contextEl) {
                contextEl.append(this.element);
                self.container = contextEl;
            }
        }

        // Events
        if(this.offcanvasControlEl) {
            this.offcanvasControlEl.addEventListener('click', (ev: MouseEvent) => {
                self.toggle();
            });
        }

        if(this.options.keyboard) {
            document.addEventListener('keyup', (ev: KeyboardEvent) => {
                if(ev.key == 'Escape') {
                    self.instance.hide();
                }
            });
        }

        this.element.addEventListener('shown.bs.offcanvas', (ev) => {
            self.handleState();
        });
        this.element.addEventListener('hidden.bs.offcanvas', (ev) => {
            self.handleState();
        });
    }

    protected toggle() {
        const self = this;
        // Handle exclusive
        if(this.options.exclusive) {
            if(self.container) {
                self.container.childNodes.forEach((node) => {
                    const el = node as HTMLElement;
                    if(el != self.element && offcanvasInstanceMap.has(el)) {
                        offcanvasInstanceMap.get(el)!.hide();
                    }
                });
            }
        }

        self.instance.toggle();
    }

    protected handleState() {
        const self = this;
        if(this.options.exclusive && this.element.classList.contains('show')) {
            offcanvasInstanceMap.forEach((bsInstance: bootstrap.Offcanvas, element: HTMLElement)=> {
                if(element != self.element && element.classList.contains('show')) {
                    bsInstance.hide();
                }
            });
        }

        if(this.offcanvasControlEl) {
            this.offcanvasControlEl.removeAttribute('aria-show');
            if(this.element.classList.contains('show')) {
                this.offcanvasControlEl.setAttribute('aria-show', 'true');
            } else {
                this.offcanvasControlEl.setAttribute('aria-show', 'false');
            }
        }
    }
}

// Observe
OffcanvasContainer.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export type { OffcanvasContainerConfig };
export default OffcanvasContainer;
